import type {
  WorksheetAssignSchedule,
  WorksheetAssignScheduleCount,
  WorksheetAssignScheduleStatus,
} from '@mathflat/domain/Worksheet'

import dateUtils from '@/utils/DateUtils'

import { SCHEDULE_LIST_STRINGS } from '../_constants/scheduleStrings'
import { formatScheduleDate, formatScheduleTime } from './scheduleFormat'

type Detail = WorksheetAssignSchedule
type Status = WorksheetAssignScheduleStatus

/** 카드 첫 줄 시각. "2026.09.18 금요일 오전 10:30" */
export const formatScheduleDateTime = (date: Date) =>
  `${formatScheduleDate(date)} ${dateUtils.toKoDayOfWeek(date)}요일 ${formatScheduleTime(date)}`

/** 실패 탭에서는 실패한 학생만 보여준다. 다른 탭은 예약 대상 전원 */
export const cardStudents = (detail: Detail, status: Status) =>
  status === 'FAILED' ? detail.students.filter((s) => s.status === 'FAILED') : detail.students

export const studentDisplayName = (student: Detail['students'][number]) =>
  student.studentName ?? SCHEDULE_LIST_STRINGS.deletedStudent

export const worksheetDisplayTitle = (detail: Detail) =>
  detail.worksheetTitle ?? SCHEDULE_LIST_STRINGS.deletedWorksheet

/** "김태련 외 3명". 한 명이면 이름만, 없으면 빈 문자열 */
export const formatStudentSummary = (names: string[]) => {
  if (names.length === 0) return ''
  if (names.length === 1) return names[0]
  return `${names[0]} 외 ${names.length - 1}명`
}

/** 카드 상태 라벨. 대기·완료는 "대기(26명)", 실패는 사유를 괄호 안에 */
export const formatStatusLabel = (detail: Detail, status: Status) => {
  if (status === 'FAILED') {
    return detail.failureScope === 'ALL'
      ? SCHEDULE_LIST_STRINGS.failureAll()
      : SCHEDULE_LIST_STRINGS.failurePartial()
  }
  return `${SCHEDULE_LIST_STRINGS.short(status)}(${cardStudents(detail, status).length}명)`
}

export const formatTabCount = (status: Status, counts: WorksheetAssignScheduleCount) => {
  const count = { WAITING: counts.waiting, FAILED: counts.failed, DONE: counts.done }[status]
  return `${SCHEDULE_LIST_STRINGS.short(status)} ${count}개`
}
